import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHotelFront = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconHotelFront",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("rect", {
    width: 20,
    height: 1,
    x: 2,
    y: 20,
    fill: "#222",
    rx: 0.5
  }), _jsx("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M5 5h14v15h-5v-5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5H5zm5.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V10h2v1.5a.5.5 0 1 0 1 0v-4a.5.5 0 0 0-1 0V9h-2V7.5a.5.5 0 0 0-.5-.5",
    clipRule: "evenodd"
  }), _jsx("rect", {
    width: 18,
    height: 2,
    x: 3,
    y: 3,
    fill: "#222",
    rx: 1
  })]
}));
IconHotelFront.displayName = 'IconHotelFront';